import React, { useMemo, useState } from "react";
import TotalCase from "../../../images/totalCase.svg";
import TotalTrey from "../../../images/total_tray.svg";
import Carts from "../../../images/total_cart.svg";
import CartsCooking from "../../../images/carts_cooking.svg";
import CartsCase from "../../../images/caseRejected.svg";

import { AddProcessingEmployeeData } from "./AddProcessingEmployeeData";
import DateSelector from "../../../components/shared/fields/DateSelector";
import GridCard from "../../../components/shared/gridCard/GridCard";
import ProcessingCharts from "./ProcessingCharts";
import {
  useGetProcessingEmployeeQuery,
  useGetProcessingSummaryQuery,
} from "./processingApi";
import { useGetAllWorkingAreasQuery } from "../../../app/globalApi";
import useTranslator from "../../../hooks/useTranslator";
import { formatDateAndTime, getCurrentDate } from "../../../helpers/Utils";
import { PROJECT_DATE_FORMAT } from "../../../helpers/constants";

const ProcessingDashboard = () => {
  const [showAddEmployment, setShowAddEmployment] = useState(false);  
  const currentDate = getCurrentDate('YYYY-MM-DD');
  const [date, setDate] = useState(currentDate);
  const [tab, setTab] = useState("dashboard");
  const { _t } = useTranslator();

  const { data: summaryData } = useGetProcessingSummaryQuery({ tab, date });
  const { data: employeeSummaryData } = useGetProcessingEmployeeQuery({
    date,
  });
  const { data: workingAreasData, isLoading: isWorkingAreasLoading } =
    useGetAllWorkingAreasQuery();

  const receivingAreaId = useMemo(() => {
    if (!workingAreasData?.data) return null;
    const receivingArea = workingAreasData.data.find(
      (area) => area.name === "Processing & Cooking Area"
    );
    return receivingArea ? receivingArea.id : null;
  }, [workingAreasData]);


  const listItems = [
    {
      label: _t("total_cases_processed", "Total Cases Processed"),
      value: summaryData?.data.total_cases_processed,
      icon: TotalCase,
    },
    {
      label: _t("total_treys", "Total Treys"),
      value: summaryData?.data.total_treys,
      icon: TotalTrey,
    },
    {
      label: _t("total_carts", "Total Carts"),
      value: summaryData?.data.total_carts,
      icon: Carts,
    },
    {
      label: _t("total_carts_in_cooking", "Total Carts in Cooking"),
      value: summaryData?.data.total_carts_in_cooking,
      icon: CartsCooking,
    },
    {
      label: _t("cart_per_case", "Cart Per Case"),
      value: summaryData?.data.total_cart_per_case?.toFixed(2),
      icon: CartsCase,
    },
    {
      label: _t("tray_per_case", "Tray Per Case"),
      value: summaryData?.data.total_trey_per_case?.toFixed(2),
      icon: TotalTrey,
    },
  ];

  return (
    <div>
      {showAddEmployment && (
        <AddProcessingEmployeeData
          show={showAddEmployment}
          setShow={setShowAddEmployment}
          record={employeeSummaryData?.data}
        />
      )}
      <div className="overview cmn_card mb-3">
        <div className="overview_header d-flex gap-2 align-items-center">
          <h6 className="mb-0 flex-grow-1">{_t("overview", "Overview")}</h6>
          <DateSelector setDate={setDate} />
        </div>
        <ul className="m-0 grid_card_wrapper">
          {listItems.map((list, index) => (
            <GridCard
              key={index}
              title={list.label}
              value={list.value}
              icon={list.icon}
              day={currentDate === date ? _t("today", "Today") : formatDateAndTime(date, PROJECT_DATE_FORMAT)}
            />
          ))}
        </ul>
      </div>
      <ProcessingCharts />
    </div>
  );
};

export default ProcessingDashboard;
